//@vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @utilities
const { formatText } = require('core/i18n').i18n;

//@commons
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');



class CancelCardPayLaterErrorStep extends React.Component {
    constructor(props) {
        super(props);
        this.backToCards = this.backToCards.bind(this);
    }

    backToCards() {
        this.props.history.push('/myprofile/cards');
    }

    render() {
        const title = formatText('cancelPayLater-errorTitle');
        const errorSubTitle = formatText('cancelPayLater-errorSubTitle')
        const goBackButtonLabel = formatText('cancelPayLater-goBackButton').toUpperCase();

        return (
            <article className="row no-gutter">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={errorSubTitle}
                    textLink={goBackButtonLabel}
                    goBackHandler={this.backToCards}
                />
            </article>
        )
    }
}

CancelCardPayLaterErrorStep.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(CancelCardPayLaterErrorStep);
